/**
 * FilterBuilder field list for the Contract Negotiations list. Enum fields use
 * `input:'select'` so conditions fold into the backend query params via the
 * ContractListSection conditionsToFilters helper. Mirrors the legacy negotiation
 * filter set: status · priority · type · stage.
 */
import type { FilterField } from '@vnetwork/ui/data';
import {
  NEGOTIATION_STATUS_OPTIONS,
  NEGOTIATION_PRIORITY_OPTIONS,
  NEGOTIATION_TYPE_OPTIONS,
  NEGOTIATION_STAGE_OPTIONS,
} from './negotiation-format';

export const negotiationFilterFields: FilterField[] = [
  {
    value: 'status',
    label: 'Status',
    input: 'select',
    options: NEGOTIATION_STATUS_OPTIONS,
  },
  {
    value: 'priority',
    label: 'Priority',
    input: 'select',
    options: NEGOTIATION_PRIORITY_OPTIONS,
  },
  {
    value: 'type',
    label: 'Type',
    input: 'select',
    options: NEGOTIATION_TYPE_OPTIONS,
  },
  {
    value: 'stage',
    label: 'Stage',
    input: 'select',
    options: NEGOTIATION_STAGE_OPTIONS,
  },
];
